
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Courses from '../components/Courses/Courses';
import Events from '../components/Event/Event';
import CeoMessage from '../components/CeoMessage/CeoMessage';
import Contact from '../components/Contact/Contact';
import useAPI from '../hooks/useAPI';


const Home = () => {
  const {
    data: homeData,
    loading,
    error,
  } = useAPI('/home');

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <Hero  data={homeData?.data?.hero} />
      <About  data={homeData?.data?.about} />
      <Services data={homeData?.data?.services} />
      <Courses data={homeData?.data?.courses} />
      <CeoMessage data={homeData?.data?.leadership} />
      <Events />
      <Contact />
    </>
  );
};

export default Home;